export default __webpack_public_path__ + "static/media/Guru-Parampara-12.35fe3455.png";